import { useId } from 'react';
import PropTypes from 'prop-types';
import { useController } from 'react-hook-form';
import { cn } from 'utils';

import { LabelStatic } from '../_shared/LabelStatic';
import { HelperText } from '../_shared/HelperText';

import './CheckboxField.css';

export const CheckboxField = ({
  checked,
  disabled,
  onChange,
  label,
  labelCss,
}) => {
  const id = useId();

  return (
    <div>
      <input
        className="checkbox-input"
        type="checkbox"
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />

      <label
        htmlFor={id}
        style={labelCss}
        className={cn('checkbox-label', disabled && 'checkbox-label--disabled')}
      >
        {label}
      </label>
    </div>
  );
};

CheckboxField.propTypes = {
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.any,
  labelCss: PropTypes.object,
};

export const RCheckboxField = ({
  name,
  title,
  label,
  control,
  labelCss,
  disabled,
  hideValidation = false,
}) => {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ name, control });

  return (
    <>
      {title && <LabelStatic>{title}</LabelStatic>}

      <CheckboxField
        checked={Boolean(value)}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
        label={label}
        labelCss={labelCss}
      />

      {!hideValidation && <HelperText>{error?.message}</HelperText>}
    </>
  );
};

RCheckboxField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  title: PropTypes.string,
  control: PropTypes.any,
  labelCss: PropTypes.object,
  disabled: PropTypes.bool,
  hideValidation: PropTypes.bool,
};
